module.exports = __webpack_public_path__ + "img/logo.89fb7b5f.png";